
import React from 'react';
import type { ParkingReservation } from '../../types';

interface ParkAndFlyReportProps {
    reservation: ParkingReservation;
}

const ParkAndFlyReport: React.FC<ParkAndFlyReportProps> = ({ reservation }) => {
    const QualityLogo = () => (
        <div className="flex items-center gap-2">
            <div className="w-16 h-16 bg-[#006837] rounded-lg flex flex-col items-center justify-center p-1">
                <div className="relative w-8 h-8 flex items-center justify-center">
                    <div className="w-7 h-7 border-[4px] border-[#FDB913] rounded-full"></div>
                    <div className="absolute bottom-0.5 right-0.5 w-4 h-[4px] bg-[#FDB913] rotate-45 rounded-full"></div>
                </div>
                <div className="text-white font-serif text-[10px] leading-none mt-0.5 font-bold">Quality</div>
                <div className="text-white font-sans text-[5px] tracking-[0.2em] leading-none mt-0.5 font-bold uppercase">Hotel</div>
            </div>
            <div className="flex flex-col">
                <span className="text-[#006837] font-serif text-xl font-bold leading-none">QUALITY</span>
                <span className="text-[#006837] font-sans text-[10px] tracking-[0.3em] font-bold leading-none">HOTEL</span>
            </div>
        </div>
    );

    const Field = ({ label, value, className = "" }: { label: string, value: string, className?: string }) => (
        <div className={`flex items-center gap-2 ${className}`}>
            <span className="text-[10pt] font-bold whitespace-nowrap min-w-[110px]">{label}:</span>
            <div className="flex-1 border-b border-black min-h-[1.2rem] px-2 text-[10pt]">
                {value}
            </div>
        </div>
    );

    return (
        <div className="w-full h-full bg-white p-4 font-sans text-black flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <QualityLogo />
                <h1 className="text-3xl font-bold">Stationnement / Parking</h1>
            </div>

            {/* Top Box */}
            <div className="border border-black p-4 mb-6">
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                    <Field label="Commis/GSA" value={reservation.authorizedBy === 'System' ? 'Reception' : reservation.authorizedBy} />
                    <Field label="Réservation #" value={reservation.confirmationNumber} />
                    <Field label="Arrivée/Arrival" value={reservation.startDate} />
                    <Field label="Retour/Return" value={reservation.endDate} />
                </div>
            </div>

            {/* Info Box */}
            <div className="border border-black grid grid-cols-2 mb-8">
                <div className="p-4 border-r border-black">
                    <h2 className="text-[11pt] font-bold underline mb-4 uppercase">Informations Client/Client Information</h2>
                    <div className="space-y-4">
                        <Field label="Nom / Name" value={reservation.guestName} />
                        <Field label="Téléphone / Phone" value={reservation.customerPhone || ""} />
                        <Field label="Courriel / e-mail" value="" />
                    </div>
                </div>
                <div className="p-4">
                    <h2 className="text-[11pt] font-bold underline mb-4 uppercase">Information Véhicule/ Vehicle</h2>
                    <div className="space-y-4">
                        <Field label="Marque / Make" value={reservation.carMakeModel || ""} />
                        <Field label="Couleur / Color" value="" />
                        <Field label="Plaque / Licence" value={reservation.vehicle_plate} />
                    </div>
                </div>
            </div>

            {/* Terms Section */}
            <div className="space-y-4 text-[9.5pt] leading-tight text-justify font-medium">
                <p>
                    En lisant et en signant ce formulaire, vous acceptez les conditions du présent bail et vous avez été prévenus qu'il y a un volume de vols de véhicules ou de contenue dans les stationnements incluant Quality Hôtel Dorval. , et compris que le Quality Hôtel Dorval n'assume aucune responsabilité pour toutes pertes et dommages. L'hôtel vous offre la possibilité de louer une serrure de volant pour un dépôt de 75$. .
                </p>
                <p>
                    Je, soussigné, demande la permission de garer ma voiture au Quality Hôtel Dorval. Compte tenue que je conserve les clés et que j'assume l'entière responsabilité de mon véhicule. Par conséquent, je dégage l'hôtel Quality Hôtel Dorval que toutes responsabilités pouvant aliéner ou endommager en partie ou en totalité le dit véhicule ou son contenue soit par vol, feu ou autre moyen, ainsi que de toutes responsabilités des accumulations de neiges soit sur ou autour du véhicule. Ce contrat est valide pour la durée complète du stationnement.
                </p>
                <p className="font-bold">
                    Ce forfait est une vente final, aucune annulation ou remboursement ne sera accorder après que le véhicule ai été stationné.
                </p>
                
                <div className="pt-2">
                    <p>
                        By reading and signing this form you acknowledge the terms of this please and have been forewarned that there is a high volume of theft of vehicles or contents at hotel parking lots including the Quality Hotel Dorval. Note that our hotel can offer you a wheel lock for a $75.
                    </p>
                    <p>
                        I, undersigned, request permission to the Quality Hotel to park my vehicle. It is understood that I retain possession of my keys and assume total responsibility. Therefore, I release the Quality Hotel Dorval of all responsibilities with regards to the car and its contents whether alienated in part / or totally damaged by the theft, fire or any other means and of all responsibilities with regard to snow accumulation on or around the vehicle. This lease is in effect for the entire length of the parking.
                    </p>
                    <p className="font-bold">
                        This package is a final sale, no cancellation or refund will be accepted after the vehicle has been parked.
                    </p>
                </div>
            </div>

            {/* Signature */}
            <div className="mt-auto pt-12">
                <div className="flex items-center gap-2">
                    <span className="text-[11pt] font-bold">Signature du Client/ Guest Signature:</span>
                    <div className="flex-1 border-b-2 border-black"></div>
                </div>
            </div>
        </div>
    );
};

export default ParkAndFlyReport;
